import {
  subDays,
  startOfDay,
  endOfDay,
  startOfWeek,
  startOfMonth,
} from 'date-fns';
import Select from 'react-select';
import DatePickerCalander from '../../../Utilities/DatePickerCalander';
import { DEFAULT_DATE_FORMATE, START_OF_WEEK } from '../../../constents';
import Button from '../../Button';

const DATE_PRESETS = [
  { key: 'TD', label: 'Today' },
  { key: '7D', label: '7 Days' },
  { key: 'TW', label: 'This Week' },
  { key: 'TM', label: 'This Month' },
  { key: '30D', label: '30 Days' },
  { key: '90D', label: '90 Days' },
  { key: 'ALL', label: 'All' },
];

const STATUS_OPTIONS = [
  { value: '', label: 'ALL' },
  { value: '1', label: 'Pending' },
  { value: '2', label: 'Scheduled' },
  { value: '3', label: 'Completed' },
  { value: '4', label: 'Canceled' },
  { value: '5', label: 'Removed' },
];

const URGENCY_OPTIONS = [
  { value: 'ALL', label: 'All Urgency' },
  { value: 'routine', label: 'Routine' },
  { value: 'urgent', label: 'Urgent' },
  { value: 'asap', label: 'ASAP' },
];

function getDateRangeForPreset(key) {
  const today = new Date();
  switch (key) {
    case 'TD':
      return { start: startOfDay(today), end: endOfDay(today) };
    case '7D':
      return { start: subDays(today, 7), end: today };
    case 'TW':
      return { start: startOfWeek(today, START_OF_WEEK), end: today };
    case 'TM':
      return { start: startOfMonth(today), end: today };
    case '30D':
      return { start: subDays(today, 30), end: today };
    case '90D':
      return { start: subDays(today, 90), end: today };
    case 'ALL':
      return { start: null, end: null };
    default:
      return { start: null, end: null };
  }
}

function ReferralSearchHead({
  referralData,
  providerOptions = [],
  setData = () => {},
  openPopup = () => {},
}) {
  const applyDatePreset = (key) => {
    const range = getDateRangeForPreset(key);
    setData((prev) => ({
      ...prev,
      filterValue: key,
      isDateRange: false,
      startDate: range.start,
      endDate: range.end,
    }));
  };

  const providerList =
    providerOptions.length > 0
      ? providerOptions.map((opt) =>
          opt.value === 'ALL'
            ? { ...opt, label: 'ALL REFERRAL PROVIDER' }
            : opt,
        )
      : [{ value: 'ALL', label: 'ALL REFERRAL PROVIDER' }];

  const selectedUrgency =
    URGENCY_OPTIONS.find(
      (opt) => opt.value === (referralData.searchTermUrgency || 'ALL'),
    ) || URGENCY_OPTIONS[0];

  const selectProps = {
    className: 'react-select-container referral-filter-select',
    classNamePrefix: 'react-select',
    menuPortalTarget: document.body,
    menuPosition: 'fixed',
    styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
  };

  return (
    <div className="bnc-mn-hdr">
      <div className="bill-dt-main-con referral-filters-wrap">
        <div className="referral-filters-body">
          <div className="bill-days-blk referral-filter-date-row">
            <span className="intake-head-inpt-main">
              <span className="intake-head-hedding">Referral Date:</span>
              {DATE_PRESETS.map((preset) => (
                <span key={preset.key} className="intake-head-inpt-sec">
                  <input
                    type="radio"
                    name="referralDatePreset"
                    checked={
                      referralData.filterValue === preset.key &&
                      !referralData.isDateRange
                    }
                    onChange={() => applyDatePreset(preset.key)}
                  />
                  <span>{preset.label}</span>
                </span>
              ))}
              <div className="intake-serch-calander-sec">
                <span className="intake-head-inpt-sec">
                  <input
                    type="radio"
                    name="referralDatePreset"
                    checked={referralData.isDateRange}
                    onChange={() =>
                      setData((prev) => ({
                        ...prev,
                        filterValue: 'D',
                        isDateRange: true,
                        startDate: null,
                        endDate: null,
                      }))
                    }
                  />
                </span>
                <span className="intake-serch-calander">
                  <DatePickerCalander
                    selectedDate={referralData.startDate}
                    setSelectedDate={(date) =>
                      setData((prev) => ({ ...prev, startDate: date }))
                    }
                    className="add-task-date-picker"
                    style={{ width: '75px' }}
                    dateFormat={DEFAULT_DATE_FORMATE}
                    maxDate={referralData.endDate}
                    editFlag={!referralData.isDateRange}
                  />
                </span>
                <span className="date-sep-blu-hdr">-</span>
                <span className="intake-serch-calander">
                  <DatePickerCalander
                    selectedDate={referralData.endDate}
                    setSelectedDate={(date) =>
                      setData((prev) => ({ ...prev, endDate: date }))
                    }
                    className="add-task-date-picker"
                    style={{ width: '75px' }}
                    dateFormat={DEFAULT_DATE_FORMATE}
                    minDate={referralData.startDate}
                    editFlag={!referralData.isDateRange}
                  />
                </span>
              </div>
            </span>
          </div>

          <div className="bill-days-blk referral-filter-status-row">
            <div className="referral-filter-status-row__inner">
              <span className="intake-head-inpt-main referral-status-radios">
                <span className="intake-head-hedding">Status:</span>
                {STATUS_OPTIONS.map((status) => (
                  <span key={status.value || 'ALL'} className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="referralStatusFilter"
                      checked={
                        (referralData.searchTermStatus || '') === status.value
                      }
                      onChange={() =>
                        setData((prev) => ({
                          ...prev,
                          searchTermStatus: status.value,
                        }))
                      }
                    />
                    <span>{status.label}</span>
                  </span>
                ))}
              </span>

              <span className="referral-filter-controls">
                <Select
                  {...selectProps}
                  value={referralData.provider}
                  options={providerList}
                  onChange={(option) =>
                    setData((prev) => ({ ...prev, provider: option }))
                  }
                />
                <Select
                  {...selectProps}
                  value={selectedUrgency}
                  options={URGENCY_OPTIONS}
                  onChange={(option) =>
                    setData((prev) => ({
                      ...prev,
                      searchTermUrgency: option?.value || 'ALL',
                    }))
                  }
                />
                <input
                  type="text"
                  className="inpt-width-nw referral-patient-search"
                  placeholder="Search patient name..."
                  value={referralData.searchTermName || ''}
                  onChange={(e) =>
                    setData((prev) => ({
                      ...prev,
                      searchTermName: e.target.value,
                    }))
                  }
                />
              </span>
            </div>
          </div>
        </div>

        <Button variant="primary" onClick={() => openPopup()}>
          New Referral
        </Button>
      </div>
    </div>
  );
}

export default ReferralSearchHead;